"use strict"
var Transform = require('stream').Transform
var inherits = require('util').inherits
var assign = require('lodash.assign')

function DataStream (options) {
  if (!(this instanceof DataStream)) {
    return new DataStream(options)
  }
  Transform.call(this, {objectMode: true})

  this.jsonStream = options.jsonStream
  this.streams = options.streams
  this.createMessage = options.createMessage
  this.streamName = this.createMessage.name
  this.path = this.createMessage.path
  this.sendCreateMessage()
}
inherits(DataStream, Transform)

var proto = DataStream.prototype

proto._transform = function (data, enc, next) {
  if (data.event) {
    this.emitEvent(data.event)
  }

  if (data.data) {
    next(null, data.data)
    return
  }

  next(null)
}

proto.emitEvent = function (event) {
  this.emit(event.name, event.data)
}

proto.sendCreateMessage = function () {
  this.jsonStream.write({action: 'create', path: this.path, name: this.streamName, options: this.createMessage.options})
}

proto.readData = function (options) {
  this.jsonStream.write({action: 'read', path: this.path, name: this.streamName, options})
}

proto.writeData = function (data) {
  this.jsonStream.write({action: 'write', path: this.path, name: this.streamName, data})
}

proto.updateOptions = function (updatedOptions) {
  var options = assign(this.createMessage.options, updatedOptions)
  this.jsonStream.write({action: 'update', path: this.path, name: this.streamName, options: options})
}

proto.destroy = function (options) {
  if (this.destroyed) { return }
  this.destroyed = true

  var sendMessage = !options || options.sendMessage !== false
  if (sendMessage) {
    this.jsonStream.write({action: 'delete', path: this.path, name: this.streamName})
  }
  this.emit('destroyed')
  this.end()
}

module.exports = DataStream
